/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { useEffect, useMemo, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useSessionUpdateMutation } from "./queries";

const useQueryParams = () => {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
};

export default function Callback() {
    const queryParams = useQueryParams();
    const [token] = useState<string | null>(queryParams.get("token"));
    const [message] = useState<string | null>(queryParams.get("msg"));
    const { mutateAsync } = useSessionUpdateMutation();

    useEffect(() => {
        if (token) {
            mutateAsync(token)
                .then(({ token: sessionToken }) => {
                    localStorage.setItem("token", sessionToken);
                    window.location.href = "/";
                })
                .catch((error) => {
                    window.location.href = `/err/${error.message}?source=trinity`;
                });
        }
    }, [mutateAsync, token]);

    useEffect(() => {
        if (message) {
            window.location.href = `/err/${message}?source=trinity`;
        }
    }, [message]);

    return (
        <Row className="align-items-center justify-content-center">
            <Col xs="auto" className="pr-1">
                <Spinner animation="border" variant="primary" size="sm" />
            </Col>
            <Col xs="auto" className="pl-1">
                Processing Trinity SSO Response
            </Col>
        </Row>
    );
}
